var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-no-wrap text-example",staticStyle:{"width":"8rem"}},[_vm._v(" This text should overflow the parent. ")])}
var staticRenderFns = []

export { render, staticRenderFns }